import { useState, useEffect, useCallback } from 'react'
import { Modal } from 'react-bootstrap'

import { toastErrorLog } from '../../../helpers/toastErrorLog'
import Hero from '../../perfil/Hero'
import './convertirATiendaOficial.css'
import {
  buscarTienda,
  actualizarTienda,
  buscarTodos,
  buscarPeriodicidadCobro
} from '../../servicios/tiendasOficialesService'
import Error from '../../ui/Error'
import LinkButton from '../../ui/LinkButton'
import DatosEmpresa from './DatosEmpresa'
import InformacionPlan from './InformacionPlan'
import Opciones from './Opciones'

const TIENDAOFICIAL_ACTIVA = 2

const ConvertirTiendaOficial = () => {
  const [showModal, setShowModal] = useState(false)
  const [tienda, setTienda] = useState({})
  const [tiendaBD, setTiendaBD] = useState({})
  const [planes, setPlanes] = useState([])
  const [nuevoPlan, setNuevoPlan] = useState(null)
  const [periodicidades, setPeriodicidades] = useState([])
  const [errores, setErrores] = useState({})
  const idUsuario = parseInt(localStorage.getItem('idUsuario'))

  const searchMethod = async () => {
    const { data } = await buscarTienda(idUsuario)
    setTiendaBD(data)
    setTienda({
      ...data,
      idUsuario
    })
    const planes = await buscarTodos('')
    setPlanes(planes.data)
    const periodicidades = await buscarPeriodicidadCobro('')
    setPeriodicidades(periodicidades.data)
  }

  useEffect(() => {
    searchMethod()
  }, [])

  const insertarTienda = async () => {
    if (!tienda.nombreTienda) {
      setErrores((prev) => ({
        ...prev,
        inputNombreTienda: 'El nombre de la Tienda no puede quedar vacío'
      }))
    }
    if (!tienda.idTiendaOficialPlan) {
      setErrores((prev) => ({
        ...prev,
        modalPlan: 'Debes elegir un tipo de plan para la Tienda Oficial'
      }))
    }
    if (!tienda.idTiendaOficialPeriodicidad) {
      setErrores((prev) => ({
        ...prev,
        modalPeriodicidad: 'Debes elegir una periodicidad de cobro para la Tienda Oficial'
      }))
    }
    if (!tienda.logoPath) {
      setErrores((prev) => ({
        ...prev,
        modalLogo: 'Debes subir una imagen para el Logo de la Tienda Oficial'
      }))
    }

    const estado = tienda.idTiendaOficialEstado
    if (estado === 1 || (nuevoPlan !== 0 && estado === TIENDAOFICIAL_ACTIVA)) {
      setShowModal(true)
    }
  }

  const modificarTienda = async () => {
    try {
      await actualizarTienda({ ...tienda, idTiendaOficialEstado: 2 })
      handleClose()
    } catch (error) {
      const mensaje = `Ocurrió un error al actualizar tienda.`
      toastErrorLog(error, mensaje, 'tiendaOficial')
    }
  }

  const actualizarDescripcion = async () => {
    const tiendaOficial = {
      descripcionTienda: tienda.descripcionTienda
    }
    await actualizarTienda(tiendaOficial)
  }

  const handleClose = () => {
    setShowModal(false)
  }

  const onSubmit = useCallback((e) => {
    e.preventDefault()
  }, [])

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <Hero />

            <hr className="hr-blue w-70" />

            <DatosEmpresa
              key={tienda.idTiendaOficial}
              tienda={tienda}
              setTienda={setTienda}
              onActualizarDescripcion={actualizarDescripcion}
              onInsertarTienda={insertarTienda}
              errores={errores}
              setErrores={setErrores}
            />
            <div className="row mt-4">
              <Opciones
                tienda={tienda}
                setTienda={setTienda}
                errores={errores}
                planes={planes}
                periodicidades={periodicidades}
                tiendaBD={tiendaBD}
                nuevoPlan={nuevoPlan}
                setNuevoPlan={setNuevoPlan}
              />
              <div className="col-1"></div>

              <InformacionPlan
                key={tienda.idTiendaOficial}
                tienda={tienda}
                planes={planes}
                nuevoPlan={nuevoPlan}
              />
            </div>

            <div className="row mt-4">
              <div className="col-12 text-center">
                <Error name="botonPagar" errores={errores}>
                  <LinkButton
                    className="btn btn-borde-verde w-60"
                    onClick={insertarTienda}
                  >
                    Revisar y Pagar
                  </LinkButton>
                </Error>
              </div>

              <Modal show={showModal} onHide={handleClose} size={'lg'} animation={false}>
                <form onSubmit={onSubmit}>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h3>Confirma los datos para finalizar la compra</h3>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      <Opciones
                        tienda={tienda}
                        setTienda={setTienda}
                        errores={errores}
                        planes={planes}
                        periodicidades={periodicidades}
                        tiendaBD={tiendaBD}
                        nuevoPlan={nuevoPlan}
                        setNuevoPlan={setNuevoPlan}
                      />
                    </div>
                    <div className="row">
                      <InformacionPlan
                        key={tienda.idTiendaOficial}
                        tienda={tienda}
                        planes={planes}
                        nuevoPlan={nuevoPlan}
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      type="button"
                      className="btn btn-enviar"
                      onClick={handleClose}
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn btn-volver-comprar"
                      onClick={() => {
                        modificarTienda()
                      }}
                    >
                      Confirmar Compra
                    </button>
                  </Modal.Footer>
                </form>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConvertirTiendaOficial
